<template>
    <div>
        <h2 class="post__title">儿童青少年性教育</h2>

        <h3 class="post__meta">by <router-link class="post__author"
          :to="`/home/team`">{{ author }}</router-link>
           	- <time>{{ prettyDate(published) }}</time>
        </h3>
      <section class="post__body rte">请允许我自我介绍： 我是张艺，新西兰注册心理师（Psychologist），现在政府儿童保护机构工作。先前是新西兰注册教师，主要教初高中音乐。2001年留学潮，我作为高中生来到新西兰留学。一人在国外的日子，辛酸苦辣大家都有体会。如今，我很庆幸能在新西兰有了自己的家。有家有爱的孩子是最幸福的，其他的都不足挂齿 – 我时刻提醒着自己。</section>
      <section class="post__body rte">转入正题。</section>
      <section class="post__body rte">昨日还粘着你的萌娃，今日问起了关于“性”的问题让你不知所措。例如“为什么同班的小男生要站着尿尿”或者 “我是从哪里来的”。更或者，你发现原先上网只对Peppa Pig感兴趣的小屁孩，现在居然有了关于“性”的搜索记录。关于“性”的话题，怎么和孩子提起？要说些什么？说多了，会引起过度的好奇; 说少了，孩子不会保护自己。好多的疑问，希望这篇文章能给你一些帮助。“性教育”这话题范围很广，今天的文章只是一个开端， 我很有兴趣与您继续探讨。由于工作原因，我经常与被性侵或性骚扰的孩子们有接触，包括中国的孩子也不少。我时常想着，如果我们能尽力地教育孩子，会不会避免一些悲剧的发生。</section>
      <section class="post__body rte">家长的顾虑：“我怕说错什么，对孩子有不好的影响”。</section>

      <section class="post__body rte">科学家 Lindberg和Maddow-Zimet对4691个15-24岁的男女生进行跟踪调查。 结果发现，多种性教育方法，每一种方式，都是有意义的。接受过性教育的男女生和没有接受过的进行对比，前者发生第一次性关系的年纪相对较晚。如果性教育里包括如何使用保护措施，前者在发生性关系的时候，会更有可能使用保护措施。所以科学告诉我们，只要你努力去进行“性教育”，结果都是有意义的。</section>
      <section class="post__body rte">而且，我个人认为，如果孩子没有从家长那里，及时得到信息。在这个信息爆炸的年代，孩子很容易上网寻找答案。孩子的生活经历不多，还没有足够能力去分辨信息的利害及真伪，就很有可能得到不健康的答案。所以，性教育需要家长的及时参与。</section>
      <section class="post__body rte">我特地问了身边的心理师同事们，请教她们对自己孩子们是怎么做性教育的。一同事说，大多数家长，包括她自己，都以为性教育是一次性的事情，和孩子谈了一次，就大功告成了。其实，性教育是一个长期的家庭话题，因为孩子在不同的阶段，会对“性”有不同的好奇和疑问。比如，孩子在小学阶段可能好奇：生殖器官长什么样？为什么我有的，你身上没有？或者，baby是怎么来的？孩子到了初高中阶段可能好奇：网上的小电影； 与异性交往中的一些困惑或冲动；甚至，自己的性倾向。总之，和孩子谈“性”，大多家长都觉得别扭，这很正常。但孩子在成长过程中，需要一个能长期倾诉和答疑解惑的对象，而家长是最安全的对象。如果这个人不是你，那就会是朋友同学和互联网。</section>
      <section class="post__body rte">所以，家长可以卸下顾虑，努力去尝试。如果你逃避，什么都不说不做，那孩子做错事的几率，就会增大数倍。</section>
      
      <section class="post__body rte mx-auto d-block col-md-5">中国孩子获取性知识的来源：</section>
      
      <img class="mx-auto d-block col-md-5" src="@/assets/images/graph.jpg" alt="image"/>
      <section class="mx-auto d-block col-md-5 topbit">图片来源 <a href="https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm">https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm</a></section>

      <!-- <div class="row">
        <img class="col-md-4" src="@/assets/images/graph.jpg" alt="image"/>
        <section class="col-md-8 bottom-align-text">图片来源 <a href="https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm">https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm</a></section>
      </div>  -->

      <section class="post__body rte">和孩子谈“性知识”比闭口不说要好。但，哪一种方式是科学上最推荐，让孩子容易接受，而且会通过行动来保护自己呢？研究表明，如果教育只停留在节欲这个层面上，效果远远不及更加全面综合的教育方法，这种方法才能更有效的减少风险因素和危险行为 (Kirby, 2008; Bearinger et al, 2007)。通俗地解释就是，如果家长只告诉孩子“你在xx岁之前，不能有性行为”，这样对孩子的影响有，但不大。作为家长都清楚，简单的告诉孩子不能做什么，效果总是不理想的。如果能加上为什么不能的原因，孩子能听进去的几率会增大。比如：看到红灯要停，为什么？因为我不想你被车撞而受伤。受伤很痛的，记得吗？上次你摔倒了，有多痛。如果严重住院很久，就不能玩了， 多没意思。性教育也是， 家长讲的内容要对孩子有意义，不是大人觉得重要的事，孩子就一定觉得重要。比如，“在xx岁之前，不能有性行为”是家长在乎的事，孩子更在乎和同龄人的友谊关系，希望得到认可关注。一个简单的“不能” 或“不准”后面，请加上几个让孩子在乎的“为什么”。抓住这个机会，和孩子一起讨论这个很有意义的话题，为什么应不应有过早的性行为 the reasons why young people have sex early vs the reasons why young people should not have sex early. 孩子会很感激你给予一个平等参与讨论的机会。网上有些文章可以一起阅读，然后讨论双方的想法。请注意，孩子一定会有些想法是你不能接受的，这很平常。作为家长可以有礼貌的说，”我不是这样认为的，因为我的想法是…这种行为的结果是…你觉得呢？” 而不是，用对错来评判孩子的意见，然后强迫孩子接受自己的观念。</section>

      <section class="post__body2 rte">可以一起阅读的文章：</section>
      <ul class="list-with-bullets">
      <li><a href="https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm">http://www.goodchoicesgoodlife.org/choices-for-young-people/articles-158918/</a></li>
      <li><a href="https://www.psychologytoday.com/nz/blog/media-spotlight/201611/whats-the-right-age-begin-having-sex">https://www.psychologytoday.com/nz/blog/media-spotlight/201611/whats-the-right-age-begin-having-sex</a></li>
      <li><a href="https://www.plannedparenthood.org/learn/birth-control/abstinence-and-outercourse/what-are-benefits-and-disadvantages-abstinence-and-outercourse">https://www.plannedparenthood.org/learn/birth-control/abstinence-and-outercourse/what-are-benefits-and-disadvantages-abstinence-and-outercourse</a></li>
      </ul>

      <section class="post__body rte">家长的顾虑：“我要如何开口？该怎么说，看什么书？”</section>

      <section class="post__body rte">性教育是家长与孩子建立良好亲子关系的机会。孩子不敢开口的时候，你来主动为孩子解答心中疑问，孩子对你的信任自然会增加， 也会拉近你和孩子的距离。怎么开口说？那就从你也曾经是个孩子，也曾经彷徨疑惑过，叙说你自己的经历开始。你童年青春期的糗事，孩子可能最感兴趣。这样可以让孩子感觉到，我现在经历的，都很正常，爸妈都曾经经历过。相应的，羞耻心和恐慌感就少了。 孩子如果觉得家长是有相似经历的过来人，而且很愿意分享，自然而然，会减少孩子去其他不健康的渠道寻求答案。</section>
      
      <section class="post__body rte">关于书的推荐，我刻意不提年龄段。因为年龄就是个数字，不能代表孩子各种思维和能力成熟的程度。比如，一个8岁的孩子，学习能力可能在10岁的程度，情感能力可能在6岁，性成熟度可能在11岁。这种情况十分普遍。所以，家长需要自己做决定，自家孩子处于一个什么程度，应该接受什么知识信息。毕竟，你最了解自己的孩子。以下的图，只是一个参考。但我觉得这个图很有意义，因为让我们意识到，性教育还包括很早期的健康教育，比如性别，身体部位的名称和作用，提高自我保护的意识。所以，家长们不用觉得性教育是别扭严肃的大事，也许你已经在做了，而且做得很好。</section>
      
      <!-- <div class="row">
        <img class="col-md-4" src="@/assets/images/sex-ed-2.jpg" alt="image"/>
        <section class="col-md-8 bottom-align-text">图片来源 <a href="http://www.chinadaily.com.cn/china/2014-03/27/content_17384157.htm">http://www.chinadaily.com.cn/china/2014-03/27/content_17384157.htm</a></section>
      </div> -->

      <img class="mx-auto d-block col-md-5" src="@/assets/images/sex-ed-2.jpg" alt="image"/>
      <section class="mx-auto d-block col-md-5">图片来源 <a href="http://www.chinadaily.com.cn/china/2014-03/27/content_17384157.htm">http://www.chinadaily.com.cn/china/2014-03/27/content_17384157.htm</a></section>

      <section class="post__body rte">我不建议让孩子自己看性教育的书，而家长不参与讨论。因为这样会让孩子觉得，爸妈不敢讨论这个话题，很容易让孩子产生羞耻感。 任何性教育的材料，书或视频，应该和孩子边看边讨论。先前提到过，不鼓励家长只告诉孩子应该怎样做，怎样想，而是应该多问孩子，“你是怎样认为的？”当家长告诉孩子一些观念的时候，一定要加上为什么。</section>
  
      <section class="post__body rte">这里，我对书进行内容的分类。其实，很多书不必买，图书馆都有借，大胆的让管理员推荐，会有很多惊喜。</section>

      <blockquote class="post__subtitle">*生育类 – 我从哪里来的？ 怀孕及生产*</blockquote>
      
      <div class="row">
        <div class="col-md-4">
        <section>Where Did I Come From? (By Peter Mayle)</section>
        <img src="@/assets/images/where-do-i.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">Where Do Babies Come From? Our First Talk About Birth (by Dr. Jillian Roberts)</section>
        <img src="@/assets/images/where-do-babies.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">What Makes a Baby (by Cory Silverbery)</section>
        <img src="@/assets/images/baby-cry.jpg" alt="image"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
        <section class="bottombit">It's So Amazing! A Book about Eggs, Sperm, Birth, Babies, and Families (by Robie. H. Harris)</section>
        <img src="@/assets/images/so-amazing.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">It’s NOT the Stork！ A Book About Girls, Boys, Babies, Bodies, Families and Friends (by Robie H Harris)</section>
        <img src="@/assets/images/stork.jpg" alt="image"/>
        </div>
      </div>

      <blockquote class="post__subtitle2">*身体器官类*</blockquote>

      <div class="row">
        <div class="col-md-4">
        <section class="bottombit">Who Has What? All About Girls' Bodies and Boys' Bodies  (by Robie H Harris)</section>
        <img src="@/assets/images/who-has-what.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">Amazing You!: Getting Smart About Your Private Parts  (by Gail Saltz)</section>
        <img src="@/assets/images/amazing-you.jpg" alt="image"/>
        </div>
      </div>

      <blockquote class="post__subtitle2">*性发育，性行为，性健康类*</blockquote>

      <div class="row">

        <div class="col-md-4">
        <section class="bottombit">It's Perfectly Normal: Changing Bodies, Growing Up, Sex, and Sexual Health (by Robie H Harris)</section>
        <img src="@/assets/images/its-notmal.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">What’s the Big Secret (By Laurie Krasny Brown)</section>
        <img src="@/assets/images/big-secret.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">Period. A Girl’s Guide (By JoAnn Loulan)</section>
        <img src="@/assets/images/period.jpg" alt="image"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
        <section class="bottombit">Being a Teen: Everything Teen Girls 	&amp; Boys Should Know About Relationships, Sex, Love, Health, Identity &amp; More (by Jane Fonda)</section>
        <img src="@/assets/images/teen.jpg" alt="image"/>
        </div>
        <div class="col-md-4">
        <section class="bottombit">What’s Happening to Me – A Boy’s Guide? (By Alex Frith)</section>
        <img src="@/assets/images/whats-happ.jpg" alt="image"/>
        </div>
      </div>

      <section class="post__body rte">家长的顾虑：“孩子太小，别说那么直白。过早教育，尺度太大，会不会有影响？”</section>
      <section class="post__body rte">性教育没有年龄限制，没有太早或太晚。因为性教育对不同阶段的孩子，有不同的内容 （请再次参考图二）。比如，学前的孩子们应该认识自己身体和器官的科学名称，而不是小鸡鸡之类的。为什么哪？因为如果连正确的名称都不能提，那就说明我们的性教育是带着羞耻感的。羞耻和自卑是紧密相连的。</section>
      <section class="post__body rte">另外，学会身体器官的科学名称， 可以让孩子更好的保护自己。之前提过，我在工作上，时常遇到被性侵的儿童和青少年， 也遇见好几个中国孩子被性侵的事件， 男女生都可能成为受害者。中国孩子太乖太天真了，被家人保护的很好，也就更不会保护自己。当不幸发生以后，都不知道怎样和老师医生警察描述具体发生了什么，因为孩子对自己的身体器官都说不清楚。有些家长在知道孩子被性侵或者性骚扰后，会问孩子，你为什么不反抗？其实就是因为平时教育不够，在那一刻孩子整个人就是懵的，或一开始没有明确意识到这样被对待是不对的，没有意识也没有力量去反抗。</section>
      <section class="post__body rte">所以，教孩子器官名称的时候，是一个很好的机会来教导孩子怎样自我保护。可以考虑用美国教育家James Stanfield的 Circles® Intimacy &amp; Relationships。用图片来帮助孩子理解 – 什么关系的人可以亲密接触，什么关系的人应该保持距离。更重要的，如果有人冒犯你，是什么样子的行为 ，要如何处理，告诉谁。我们不能假设孩子知道。有很多孩子不知道，性侵是什么，哪里不应该被碰，哪些话说出来是冒犯。家长有责任保护孩子，这个大家都知道。但保护孩子也包括，教育孩子，让他们有自我保护的能力。</section>
      <section class="post__body rte">总之，性教育，没有过早的说法。人总是在不太清楚状况的时候，好奇心最强烈。事情都讲清楚了，好奇心自然就减少了。再者，孩子带着好奇心的性行为，与有充分知识和安全保护意识的性行为相比，哪个危险性更大呢？</section>

      <section class="post__body rte">适合上学的孩子和青少年：</section>
      <div class="row">
        <img class="col-md-6" src="@/assets/images/circles2.png" alt="image"/>
      </div>
      <section class="row mx-auto d-block col-md-10 topbit">来源 <a href="http://rse.fpv.org.au/wp-content/uploads/2015/06/Activity-3-4_13.3.pdf">http://rse.fpv.org.au/wp-content/uploads/2015/06/Activity-3-4_13.3.pdf</a></section>

      <section class="post__body rte">年龄小的孩子，可以用照片来做，如下图：</section>

      <img class="mx-auto d-block col-md-7" src="@/assets/images/intimacy.jpg" alt="image"/>
      <section class="mx-auto d-block col-md-7 topbit">图片来源 <a href="http://www.autismtopics.org/t25%20autism%20development.html">http://www.autismtopics.org/t25%20autism%20development.html</a></section>

      <section class="post__body rte topbit">家长的顾虑：“男女有别 。性教育， 儿子是爸爸的事，女儿是妈妈的事， 男女生，分开讲。 ”</section>
      <section class="post__body rte">“了解异性的身体，就会更加理解对方。” - 李双双，持证性教育讲师</section>
      <section class="post__body rte">来源 <a href="http://www.xinhuanet.com/legal/2018-11/21/c_1123743516.htm">http://www.xinhuanet.com/legal/2018-11/21/c_1123743516.htm</a></section>
      <section class="post__body rte">国内少有的持证性教育讲师李双双提到一件发生在冬令营的事。课堂上，学生要自己查阅青春期的生理知识并讲解，一位高中男生发言说：“原来那几天女性的情绪会发生变化，怪不得我妈每个月都有心情不好的时候，原来她不是故意对我发脾气，不能怪她。” 男孩的妈妈当时就坐在讲台下，听完儿子的话，她眼泪一下子就流了出来。</section>
      <section class="post__body rte">作为妈妈的，大多希望儿子以后是懂得尊重女性的好男人。作为爸爸的，大多希望女儿能被未来的伴侣爱护和尊敬。如果男生不了解女生经期的烦恼，怀孕生产的艰辛等等。很难想象，这个男生，是个会体谅照顾老婆的男人。一位心理师同事和我分享她青春期的时候，很好奇男生的身体构造，但那个时候，没有网络，她只有去图书馆找书看，但也没有找到有用的资料，很失望。她的好奇心慢慢积累转变成不安和烦躁，直到她开明的父母和她讲解，给她看了一些书以后，她心里的石头才放下来。她觉得，原来，也没啥大不了啊。</section>
      <img class="mx-auto d-block col-md-4" src="@/assets/images/sex-ed.png" alt="image"/>
      
      <section class="post__body rte">家长的顾虑：“学校不是有性教育吗, 为什么我还要参与？”</section>
      <section class="post__body rte">健康学家们Shtarkshall，Santelli和Hirsch指出，长期良好的性教育，和孩子的身心健康以及社交能力是紧密相连的。其实孩子在很早期就有接触“性”的机会，比如洗澡，上厕所，换衣服， 妈妈喂奶和家人拥抱。适当地进行教育，是家长传递价值观和道德观的时机。这些很早期的性教育，比如身体部位的名称，自我保护的方式，一般都很容易被忽视。</section>
      <section class="post__body rte">学校的性教育是必要的，但只发生在一段时间里， 这不是长期的教育。及时长期的性教育，可以让孩子少吃些苦头。举个例子： 有性教育高级讲师资格证的赵红梅提到，她印象最深的是一个女孩，发育比同学早。她一直很自卑，还常被同学嘲笑。上完性教育课后，她有种恍然大悟的表情，还对同学说，这是她在成长，不应该难为情。如果这个女孩的家长及时提供教育，女孩也许不会困扰在自卑里那么久，等到学校教育才恍然大悟。例子来源 <a href="http://www.xinhuanet.com/legal/2018-11/21/c_1123743516.htm">http://www.xinhuanet.com/legal/2018-11/21/c_1123743516.htm</a></section>
      <section class="post__body rte">再说，学校的性教育里，没有包括家庭独特的观念，也许你家是传统的，或有宗教信仰。在新西兰，性教育是教很基本的知识，比如，如何使用安全套。但什么时候适合发生性关系，为什么有时候不适合，有压力的时候怎么处理怎样拒绝，这些重要的问题，不是每个老师都讲的。所以作为家长，应该意识到学校性教育不是万能的，性教育的最大责任，还是在家长身上。</section>
      <section class="post__body rte">我的kiwi同事们都感到，对孩子谈性教育多少有点别扭。看来，不只是中国家长的难题。我相信很多家长都会非常努力，为孩子的安全健康，来挑战自己。</section>
      
      <section class="post__body rte">其他资料：</section>
      <section class="post__body rte">实施性教育的几个重点：<a href="https://www.mayoclinic.org/healthy-lifestyle/sexual-health/in-depth/sex-education/art-20044034">https://www.mayoclinic.org/healthy-lifestyle/sexual-health/in-depth/sex-education/art-20044034</a></section>
      <section class="post__body rte">孩子不同时期健康和不健康的性行为：<a href="https://education.nt.gov.au/__data/assets/image/0010/731683/traffic_lights_guide.jpg">https://education.nt.gov.au/__data/assets/image/0010/731683/traffic_lights_guide.jpg</a></section>
      <section class="mx-auto d-block col-md-4 post__body rte">- 今天到此结束,谢谢阅读 -</section>
      <section class="mx-auto d-block col-md-5 post__body rte">请积极提供评论，反馈和留言。我会继续努力写的。</section>
      
      <div class="row mx-auto col-md-6">
        <div class="col-md-4">
        <img class="imagestyle2 mx-auto d-block" src="@/assets/images/yi_2020.png" alt="image"/>
        </div>
        <div class="col-md-6">
          <section class="post__body rte">张艺 – 新西兰注册心理师</section>
          <section class="post__body rte">New Zealand Registered Psychologist</section>
          <section class="post__body rte"><a href="https://www.reachingpotential.co.nz">reachingpotential.co.nz</a></section>
            <img class="col-md-6" src="@/assets/images/yi_weechat.jpg" alt="image"/>
            <section class="post__body rte">微信号：YZNZ2013</section>
        </div>
      </div>

      <section class="post__body rte">谢谢Stella Wang帮我校对。Stella是新西兰注册幼儿教育老师。 如有babysitting需要，请联系她。</section>
      
      <div class="row mx-auto col-md-6">
        <div class="col-md-3">
        <img src="@/assets/images/stella-we-chat.png" alt="image"/>
        </div>
        <div class="col-md-6">
          <section class="post__body rte">微信号：wang_xiaokuang</section>
        </div>
      </div>

      <blockquote class="post__subtitle">参考文献 References</blockquote>
      <section class="post__body3 rte">Bearinger, L. H., Sieving, R. E., Ferguson, J. & Sharma, V. (2007). “Global perspectives on the sexual and reproductive health of adolescents: Patterns, prevention, and potential”. Lancet, 369, 1220–31.</section>
      <section class="post__body3 rte">Kirby, D. (2008). “The impact of abstinence and comprehensive sex and STD/HIV education programs on adolescent sexual behavior”. Sexuality Research & Social Policy, Vol. 5, Issue 3, pp. 18–27.</section>
      <section class="post__body3 rte">Lindberg, L. D., & Maddow-Zimet, I. (2012). Consequences of sex education on teen and young adult sexual behaviors and outcomes. Journal of Adolescent Health, 51(4), 332-338.</section>
      <section class="post__body3 rte">Shtarkshall, R. A., Santelli, J. S., & Hirsch, J. S. (2007). Sex education and sexual socialization: Roles for educators and parents. Perspectives on sexual and reproductive health, 39(2), 116-119.</section>

      <section class="post__body3 rte"><a href="http://rse.fpv.org.au/wp-content/uploads/2015/06/Activity-3-4_13.3.pdf">http://rse.fpv.org.au/wp-content/uploads/2015/06/Activity-3-4_13.3.pdf</a></section>

      <section class="post__body3 rte"><a href="http://www.autismtopics.org/t25%20autism%20development.html">http://www.autismtopics.org/t25%20autism%20development.html</a></section>
      <section class="post__body3 rte"><a href="http://www.chinadaily.com.cn/china/2014-03/27/content_17384157.htm">http://www.chinadaily.com.cn/china/2014-03/27/content_17384157.htm</a></section>
      <section class="post__body3 rte"><a href="https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm">https://www.chinadaily.com.cn/china/2013-05/31/content_16551960.htm</a></section>
      <section class="post__body3 rte"><a href="http://www.goodchoicesgoodlife.org/choices-for-young-people/articles-158918/">http://www.goodchoicesgoodlife.org/choices-for-young-people/articles-158918/</a></section>
      <section class="post__body3 rte"><a href="http://www.xinhuanet.com/legal/2018-11/21/c_1123743516.htm">http://www.xinhuanet.com/legal/2018-11/21/c_1123743516.htm</a></section>

      <section class="post__body3 rte"><a href="https://www.plannedparenthood.org/learn/birth-control/abstinence-and-outercourse/what-are-benefits-and-disadvantages-abstinence-and-outercourse">https://www.plannedparenthood.org/learn/birth-control/abstinence-and-outercourse/what-are-benefits-and-disadvantages-abstinence-and-outercourse</a></section>
      <section class="post__body3 rte"><a href="https://www.psychologytoday.com/nz/blog/media-spotlight/201611/whats-the-right-age-begin-having-sex">https://www.psychologytoday.com/nz/blog/media-spotlight/201611/whats-the-right-age-begin-having-sex</a></section>
      <section class="post__body3 rte"><a href="https://www.mayoclinic.org/healthy-lifestyle/sexual-health/in-depth/sex-education/art-20044034">https://www.mayoclinic.org/healthy-lifestyle/sexual-health/in-depth/sex-education/art-20044034</a></section>
      <section class="post__body3 rte"><a href="https://education.nt.gov.au/__data/assets/image/0010/731683/traffic_lights_guide.jpg">https://education.nt.gov.au/__data/assets/image/0010/731683/traffic_lights_guide.jpg</a></section>
      <!-- <footer class="post__footer">
        <vue-disqus v-if="commentsReady" shortname="vue-blog-demo"
          :key="post" :identifier="post" :url="`https://vue-blog-demo.netlify.com/read/${post}`"/>
      </footer> -->
      </div>
</template>

<script>
import { kebabify, prettyDate } from '../helpers'
export default
{
  data() {
    return {
      author: 'Yi Zhang',
      published: '2020-02-13T18:17:00Z'
    }
  },
    methods: {
        kebabify,
        prettyDate
    }
}
</script>

<style>
@media (min-width: 768px ) {
  .row {
      position: relative;
      padding: 1.25rem 1.25rem 1rem;
  }

  .bottom-align-text {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.list-with-bullets li::before {
  padding: 0.25rem 1.25rem 0rem;
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: black; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */ 
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: 10em; /* Also needed for space (tweak if needed) */
}

.topbit {
  padding-top: 0.5rem;
}

.bottombit {
  padding-bottom: 0.5rem;
}

.imagestyle2
{
  width: 8em;
}
</style>
